var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[(_vm.isFFForUnset)?_c('fff-container-panel'):_c('cnc-container-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }